import { Stack } from "@mantine/core"
import { useNavigate } from "react-router-dom"

import { TreeNodeType } from "@costory/types/endpoints/folders"

import { FileExplorer } from "@costory/front/components/FileExplorer/FileExplorer"

export const ReportsPage = () => {
  const navigate = useNavigate()

  const onOpenDashboard = (id: string, newWindow = false) => {
    const path = "/dashboards/" + id
    if (newWindow) {
      window.open(path, "_blank")
    } else {
      navigate(path)
    }
  }

  const onOpenSavedView = (id: string, newWindow = false) => {
    const path = "/explorer/views/" + id
    if (newWindow) {
      window.open(path, "_blank")
    } else {
      navigate(path)
    }
  }

  const handleDoubleClick = (
    id: string,
    type: TreeNodeType,
    event?: React.MouseEvent,
  ) => {
    const newWindow = event?.metaKey || event?.ctrlKey
    switch (type) {
      case TreeNodeType.Dashboard:
        onOpenDashboard(id, newWindow)
        break
      case TreeNodeType.SavedView:
        onOpenSavedView(id, newWindow)
        break
      default:
        break
    }
  }

  return (
    <Stack h="80vh">
      <FileExplorer
        optionNewDashboardButton
        enableFileActions
        onDoubleClick={handleDoubleClick}
        onOpenDashboard={onOpenDashboard}
        onOpenSavedView={onOpenSavedView}
        defaultShouldShowSavedViews={undefined}
        defaultShouldShowDashboards={undefined}
        isInSaveMode={false}
      />
    </Stack>
  )
}
